
import { Component, Vue } from "vue-property-decorator";
import breakpoint from "@/mixins/breakpoint.ts";

@Component({
  mixins: [breakpoint],
  components: {},
})
export default class App extends Vue {}
